import { FilterUtils } from '@elotech/components';
import { isNumber } from 'common/utils';
import { axios } from 'libs';

const resource = '/logradouros';
const defaultSort = {
  sort: 'id,asc'
};

export const findAllAutocomplete = (
  searchParam = '',
  pagination,
  sort = defaultSort,
  cidade
) => {
  let search = isNumber(searchParam)
    ? `id==${searchParam}`
    : FilterUtils.buildFilter(['descricao'])(searchParam);

  search += ` and cidade.id==${cidade.id} `;

  return axios.get(resource, {
    params: {
      search,
      ...sort,
      ...pagination
    }
  });
};

export const findAll = (search = '', pagination, sort = defaultSort) => {
  return axios.get(resource, {
    params: {
      search,
      ...pagination,
      ...sort
    }
  });
};

export const deleteById = id => {
  return axios.delete(`${resource}/${id}`);
};

export const save = logradouro => {
  return logradouro.id
    ? axios.put(`${resource}/${logradouro.id}`, logradouro)
    : axios.post(resource, logradouro);
};

export const findById = id => {
  return axios.get(`${resource}/${id}`);
};
